/**
 * @module store/modules/apieditor/mutations
 * @description API Editor Vuex mutations for managing state.
 */

import { MutationTree } from "vuex/types";
import Vue from "vue";
import { ApiContent, ApiEditorState, Apis, Mappings } from "./types";

const mutations: MutationTree<ApiEditorState> = {
  /**
   * Sets all API configurations in the state.
   *
   * @param {ApiEditorState} state - Current module state
   * @param {Apis} payload - API configurations object
   */
  SET_APIS(state, payload: Apis) {
    Vue.set(state, "apis", payload);
  },
  /**
   * Sets all API mappings in the state.
   *
   * @param {ApiEditorState} state - Current module state
   * @param {Mappings} payload - API mappings object
   */
  SET_API_MAPPINGS(state, payload: Mappings) {
    Vue.set(state, "mappings", payload);
  },
  /**
   * Sets API content in the state.
   *
   * @param {ApiEditorState} state - Current module state
   * @param {ApiContent} payload - API content object
   */
  SET_API_CONTENT(state, payload: ApiContent) {
    Vue.set(state, "contents", payload);
  },
  /**
   * Deletes an API from the state by name.
   *
   * @param {ApiEditorState} state - Current module state
   * @param {string} payload - API name to delete
   */
  DELETE_API(state, payload) {
    Vue.delete(state.apis, payload);
  },
  /**
   * Creates a new API mapping in the state.
   *
   * @param {ApiEditorState} state - Current module state
   * @param {Object} payload - Mapping data with name property
   */
  CREATE_API_MAPPING(state, payload) {
    Vue.set(state.mappings, payload.name, payload);
  },
  /**
   * Deletes an API mapping from the state by name.
   *
   * @param {ApiEditorState} state - Current module state
   * @param {string} payload - Mapping name to delete
   */
  DELETE_API_MAPPING(state, payload) {
    Vue.delete(state.mappings, payload);
  },
};

export default mutations;
